import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {AdditionalGroupProps, translatedAdditionalGroupProps} from '../types';
import additionalGroupsKeys from '../util/additional-groups-keys';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CreateAdditionalGroupProps
  extends Omit<AdditionalGroupProps, 'id'> {
  baseAdditionalGroupId?: string;
}

export const translatedCreateAdditionalGroupProps: TranslatedKeys<CreateAdditionalGroupProps> =
  {
    ...translatedAdditionalGroupProps,
    baseAdditionalGroupId: 'Copiar adicionais?',
  };

const useCreateAdditionalGroup = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: AdditionalGroupProps) =>
    create(additionalGroupsKeys.list(), data);

  return useApiMutation<AdditionalGroupProps>({
    url: '/additional-groups',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar grupo de adicional',
    successTitle: 'Cadastrar grupo de adicional',
    successMessage: 'Grupo de adicional cadastrado com sucesso',
    redirectUrl: '/menu/additional-groups',
    onSuccess,
  });
};

export default useCreateAdditionalGroup;
